import * as React from 'react';
import { sortBasedOnList } from '../utils';

export type Table19aData = { [key: string]: { [key: string]: ITable19aRow } };

export interface ITable19aProps {
  data: Table19aData;
}

interface ITable19aRow {
  workersPresentTotal: number;
  workersPresentYes: number;
  workersPresentNo: number;
  workersPresentNotApplicable: number;
  workersPresentUnknown: number;
  workersPresentNotStated: number;
}


interface ITable19aState {
}

const sortOrder = [
  "Intermittent or Moving Work",
  "Lane Closure",
  "Lane Shift/Crossover",
  "Work on Shoulder or Median",
  "Not Applicable",
  "Other",
  "Unknown",
  "Not Stated",

  "Before Work Zone Warning Sign",
  "Advance Warning Area",
  "Transition Area",
  "Activity Area",
  "Termination Area",
  "Not Applicable",
  "Other",
  "Unknown",
  "Not Stated",
];

export default class Table19a extends React.Component<ITable19aProps, ITable19aState> {
  public constructor(props: any) {
    super(props);
  };

  componentDidMount = () => {
  }

  public render() {
    return (
      <>
        {this.props.data ?
          <table className="ss-table summaryTable1">
            <colgroup>
              <col width={28} />
              <col width={380} />
            </colgroup>
            <thead>
              <tr>
                <th colSpan={2} rowSpan={2} className="border-right-bold">
                  <div className="ss-table-header">
                    <span className="header-number">19a</span>
                    <span className="header-text">WORKZONE</span>
                  </div>
                </th>
                <th colSpan={6}>WORKERS PRESENT</th>
              </tr>
              <tr>
                <th>TOTAL</th>
                <th>YES</th>
                <th>NO</th>
                <th>NOT APPLICABLE</th>
                <th>UNKNOWN</th>
                <th>NOT STATED</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(this.props.data).map((key, index) =>
                sortBasedOnList(this.props.data[key], sortOrder).map((key2, index2) =>
                  <tr
                    key={key2}
                    style={index > 0 && index2 === 0 ? { borderTop: '2px solid black' } : {}}
                  >
                    {index2 === 0 &&
                      <td rowSpan={Object.keys(this.props.data[key]).length}>
                        <p
                          className="atIntersectionVerticalColumnSmall"
                          style={{ width: '15px' }}
                        >
                          {key}
                        </p>
                      </td>
                    }
                    <td className="border-right-bold">{key2}</td>
                    <td className="numberTotals">{this.props.data[key][key2].workersPresentTotal}</td>
                    <td className="numberTotals">{this.props.data[key][key2].workersPresentYes}</td>
                    <td className="numberTotals">{this.props.data[key][key2].workersPresentNo}</td>
                    <td className="numberTotals">{this.props.data[key][key2].workersPresentNotApplicable}</td>
                    <td className="numberTotals">{this.props.data[key][key2].workersPresentUnknown}</td>
                    <td className="numberTotals">{this.props.data[key][key2].workersPresentNotStated}</td>
                  </tr>)
              )}
            </tbody>
          </table>
          : <p>Loading...</p>}
      </>
    );
  }
}
